import type React from "react";
import { LandingPage } from "../modules/public/LandingPage";
import creatorContent from "../modules/public/lp-content/creator.json";
import defaultContent from "../modules/public/lp-content/default.json";
import lpContent from "../modules/public/lp-content/lp.json";
import newbizContent from "../modules/public/lp-content/newbiz.json";
import type { LandingContent, SiteId } from "../modules/public/lp-content/types";
import { validateLandingContentCatalog } from "../modules/public/lp-content/validate";

export type SiteConfig = {
	siteId: SiteId;
	hosts: string[];
	themeClass: string;
	landing: React.ComponentType;
	lpContentFile: string;
	lpContent: LandingContent;
	initialFilters?: { role?: string; category?: string };
	/** SYS_AGENT_FILTER_LIST へ書く値。未指定なら属性を書かず Agent は全表示。 */
	agentFilterValue?: string;
};

export const SITES: SiteConfig[] = [
	{
		siteId: "lp",
		hosts: ["lp.agentry.jp"],
		themeClass: "site-lp",
		landing: LandingPage,
		lpContentFile: "lp.json",
		lpContent: lpContent as LandingContent,
		initialFilters: { role: "design", category: "web" },
		agentFilterValue: "lp",
	},
	{
		siteId: "newbiz",
		hosts: ["newbiz.agentry.jp"],
		themeClass: "site-newbiz",
		landing: LandingPage,
		lpContentFile: "newbiz.json",
		lpContent: newbizContent as LandingContent,
		initialFilters: { role: "management", category: "consulting" },
		agentFilterValue: "newbiz",
	},
	{
		siteId: "creator",
		hosts: ["creator.agentry.jp"],
		themeClass: "site-creator",
		landing: LandingPage,
		lpContentFile: "creator.json",
		lpContent: creatorContent as LandingContent,
		initialFilters: { role: "creator" },
		agentFilterValue: "creator",
	},
	{
		siteId: "default",
		hosts: ["agentry.jp", "www.agentry.jp", "stg.agentry.jp", "app.agentry.jp"],
		themeClass: "site-default",
		landing: LandingPage,
		lpContentFile: "default.json",
		lpContent: defaultContent as LandingContent,
	},
];

validateLandingContentCatalog(SITES);

export const DEFAULT_SITE = SITES[3] as SiteConfig;

const SITE_QUERY_HOSTS = new Set([
	"localhost",
	"127.0.0.1",
	"::1",
	"stg-v1.agentry.jp",
	"agentry-stg-v1.fly.dev",
]);

export function resolveSite(hostname: string, search: string): SiteConfig {
	const host = hostname.trim().toLowerCase().replace(/\.$/, "");
	if (SITE_QUERY_HOSTS.has(host)) {
		const requested = new URLSearchParams(search).get("site");
		const selected = SITES.find((site) => site.siteId === requested);
		if (selected) return selected;
	}

	const hosted = SITES.find((site) => site.hosts.includes(host));
	if (hosted) return hosted;

	return DEFAULT_SITE;
}
